module.exports = __webpack_public_path__ + "media/images/archive-32fe4ccb5cb3e181829efefb03b5c0a3.svg";